import { SituacaoCompra } from "../shared/enums/situacao-compra.enum";
import { SituacaoPedido } from "../shared/enums/situacao-pedido.enum";
import { DadoBancarioCedente } from "./dado-bancario-cedente";
import { DadosBancarioDestino } from "./dados-bancario-destino";

export class PurchaseItens {
    public ehEditavel: boolean;
    purchaseItemId: number;
    purchaseId: number;
    productId: number;
    order: Order;
}
export class Order {
    orderId: number;
    assignorContractId: number;
    managerId: number;
    productCategory: number;
    orderValue: number;
    orderValueToDeliver: number;
    purchaseItemId: number;
    orderState: number;
    orderDescription: string;
    productGuid: string;
    productDescription: string;
    productColor: string;
    productIcon: string;
    orderStateDescription: string;
    releaseDate: Date;
    dueDate: Date;
    totalFee: number;
    totalFeePercent: number;
    isPercent: boolean;
    orderItens: OrderItens[];
}
export class OrderItens {
    document: any;
    orderItemId: number;
    collaboratorId: number;
    cardId: number;
    hasApp: boolean;
    hasCard: boolean;
    referenceValue: number;
    providedValue: number = 0;
    orderItemState: number;
    regularityId: number;
    hasAppDescription: string;
    registry: string;
    name: string;
    regularityDescription: string = null;
    comments: string = null;
    orderItemStateDescription: string;
}

export class PurchasesList{
    totalPages: number;
    totalPurchases: number;
    purchases: Purchase[];
}

export class Purchase {
    public toCancel: boolean;
    purchaseUseBalance: boolean;
    isFlexPurchase: boolean;
    needChangeDate: boolean;
    purchaseId: number;
    assignorId: number;
    paymentMethodId: number;
    purchaseValue: number;
    purchaseValuePay: number;
    purchaseToPayValue?: number;
    purchaseValueToDeliver: number;
    depositId: number;
    purchaseDescription: string;
    managerGuid: string;
    identifier: string;
    purchaseDate: Date;
    purchaseItens: PurchaseItens[];
    payment: Payment;
    pix: Pix;
    boleto: Boleto;
    group: Group;
    purchaseFee: number;
    anexoId?: number;
    flexIndividual?: boolean = false; 

    constructor(
        public purchaseState: number,
        public purchaseStateDescription:string,
        public situacaoId?: SituacaoCompra,
        ){

    }
}
export class Payment {
    bankGuid: string;
}

export class PurchaseResponse {
    payment: any;
    pdf?: string;
    identificador?: number;
}
export class PurchaseSummary {
    purchaseId: number;
    purchaseValue: number;
    situationId: number;
    situationDescription: string;
    purchaseDescription: string;
    createdDate: Date;
    releaseDate: Date;
    products: Array<ProductsPurchase>
}
export class ProductsPurchase
{
    productId: number;
    productGuid: string;
    productDescription: string;
    productColor: string;
    productIcon: string;
}
export class OrderSummary {
    id: number;
    purchaseId: number;
    productId: number;
    totalValue: number;
    situationId: number;
    status: string;
    productGuid: string;
    productDescription: string;
    productColor: string;
    productIcon: string;
    createDate: Date;
    paymentDate: Date;
    releaseDate: Date;
    orderItens: OrderItens[];
}

export class Pix{
    id: number;
    valor: number;
    brCode: string;
    imagemBRCode: string;
}

export class Boleto{
    arquivo: string;
}

export class Group{
    groupId: number;
    groupGuid: string;
}

export class FastPurchase{
    constructor(
        public value: number,
        public fee: number,
        public feeValue: number,
        public productId: number,
        public assignorContractId: number,
        public regularityId: number,
        public referenceValue: number,
        public productGuid: string,
        public productName: string,
        public regularityDescription: string,
        public isPercent: boolean,
        public cardId?:number){
    }
}
